import { useNavigate } from 'react-router-dom';
import { seoArticles } from '@/mocks/seo-articles';

export default function SeoArticlesSection() {
  const navigate = useNavigate();

  return (
    <section id="seo-articles" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold tracking-wide uppercase mb-4">
            In-Depth Guides
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Basetao <span className="italic text-primary-600">Guides &amp; Resources</span>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            Explore our collection of comprehensive Basetao guides — each one packed with expert insights, practical tips, and real-world advice to help you shop smarter and save more.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {seoArticles.map((article) => (
            <button
              key={article.slug}
              onClick={() => navigate(`/article/${article.slug}`)}
              className="group text-left bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/40 transition-all duration-300 cursor-pointer w-full"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.headline}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-white/85 backdrop-blur-sm text-foreground-800 text-[10px] font-semibold tracking-wide uppercase">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.headline}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed mb-3 line-clamp-2">
                  {article.intro}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-[11px] text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line text-[10px]"></i> {article.readTime}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:gap-2 transition-all">
                    Read Article <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}